export default {
  token: (state: any) => state.login.token,
  siderType: (state: any) => state.login.siderType,
  lang: (state: any) => state.login.lang,
  tabsList: (state: any) => state.login.tabsList,
  avatar: (state: any) => state.user.avatar,
  name: (state: any) => state.user.name,
  introduction: (state: any) => state.user.introduction,
  roles: (state: any) => state.user.roles,
  userId: (state: any) => state.user.userId,
  sidebarLogoType: (state: any) => state.login.sidebarLogoType,
  moshiNum: (state: any) => state.login.moshiNum,
  accessToken: (state: any) => state.login.accessToken,
  refreshToken: (state: any) => state.login.refreshToken,
  expireTime: (state: any) => state.login.expireTime,
  refreshImgCode: (state: any) => state.login.refreshImgCode
}
